import React from "react";
import { object, number } from "prop-types";
import { Headline, Subheadline } from "@quintype/arrow";

import StoryElements from "../story-elements";
import CardImage from "../../atoms/cardimage";
import AuthorAndTimeStamp from "../story-header/author-and-timestamp";

import "./exclusive.m.css";
import Resizer from "../story-header/resizer";

const PVExclusiveStoryTemplate = ({ story, index, aspectRatio, imageType }) => {
  return (
    <>
      <div styleName="wrapper">
        <div styleName="header-content">
          <CardImage story={story} aspectRatio={aspectRatio} imageType={imageType} renderedWidth={720} widths={[700]} />
          <div styleName="headline">{story.headline}</div>
        </div>
        <div styleName="story-content">
          <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
          <div styleName="exclusive-author-wrapper">
            <AuthorAndTimeStamp story={story} isPVExclusive={true} />
            <Resizer story={story} />
          </div>
          <div styleName="content">
            <StoryElements story={story} cards={story.cards} index={index} />
          </div>
        </div>
      </div>
      {/* <MoreNews story={story} /> */}
    </>
  );
};

PVExclusiveStoryTemplate.propTypes = {
  story: object,
  index: number
};

PVExclusiveStoryTemplate.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9"
};

const ExclusiveStory = (props) => {
  return <PVExclusiveStoryTemplate story={props.story} index={props.index} />;
};

ExclusiveStory.propTypes = {
  story: object,
  index: number
};

export default ExclusiveStory;
